





































import { Component, Vue } from 'vue-property-decorator';
import Loading from '@/components/Loading.vue';
import { ActionNames } from '@/constants/ActionNames';

@Component({
  components: {
    Loading,
  },
})
export default class ForgotPassword extends Vue {
  public email: string = '';

  public loading: boolean = false;

  public error: {
    type: string,
    message: string,
    show: boolean,
  } = {
    show: false,
    type: '',
    message: '',
  };

  public async doPasswordReset() {
    this.loading = true;

    if (!this.email) {
      this.error = {
        show: true,
        type: 'warning',
        message: 'Vul een email in',
      };
    } else {
      const success = await this.$store.dispatch(ActionNames.FORGOT_PASSWORD, this.email);

      if (success) {
        this.error = {
          show: true,
          type: 'success',
          message: 'Er is een nieuw wachtwoord naar je email verstuurd',
        };
      } else {
        this.error = {
          show: true,
          type: 'warning',
          message: 'Er ging iets fout tijdens het aanvragen van een nieuw wachtwoord',
        };
      }
    }

    this.loading = false;
  }
}
